import { Handle, Position, useStore } from 'reactflow';
import CustomMovableHandle from '../../CustomMovableHandle';
import { useState } from 'react';
import NodeToolbar from '../../NodeToolbar';
import VrrpIcon from '@shared/static/icons/VrrpIcon';
import { Box } from '@mui/material';
import { NODE_DEFAULT_PORTS, NODE_SIZES } from '@pages/schemes/constants';
import useRotation from '@pages/schemes/hooks/useRotation';
import useSelectionStyle from '@pages/schemes/hooks/useSelectionStyle';
import useDynamicHandlePosition from '@pages/schemes/hooks/useDynamicHandlePosition';

const HANDLES_POOL = ['port0', 'port1'];

export function VRRPNode({ id, type, data, selected, isConnectable }) {
    const isNodeDraggable = useStore((state) => state.nodesDraggable);
    // eslint-disable-next-line no-unused-vars
    const [_rotateControlRef, rotation] = useRotation(data, id);
    const selectionStyle = useSelectionStyle(selected);
    const [selectedHandleId, setSelectedHandleId] = useState(data.selectedHandleId);
    const [handle_1_Position, setInitialHandle_1_Position] = useDynamicHandlePosition(
        rotation,
        data,
        HANDLES_POOL[1],
        Position.Right,
    );

    const mapHandleIdToUseDynamicHandlePosition = {
        [HANDLES_POOL[1]]: [handle_1_Position, setInitialHandle_1_Position],
    };

    return (
        <Box
            style={{
                ...selectionStyle,
                maxWidth: NODE_SIZES['vrrp'].width,
                maxHeight: NODE_SIZES['vrrp'].height,
                transform: `rotate(${rotation}deg)`,
                padding: '2px',
            }}
            className="reactflow__cloud-node reactflow__cloud-node_square-border"
        >
            <VrrpIcon />
            <Box className="reactflow__zone-title" style={{ color: 'white' }}>
                {type.toUpperCase()}
            </Box>
            <Handle
                type="target"
                id={NODE_DEFAULT_PORTS['vrrp'][0]['name']}
                position={Position.Top}
                style={{
                    boxSizing: 'border-box',
                    top: -1,
                    width: '102%',
                    height: '102%',
                    backgroundColor: 'unset',
                    border: '1px solid var(--verify-color)',
                }}
                isConnectable={isConnectable}
                isConnectableStart={false}
            />
            <CustomMovableHandle
                style={{ width: '10px', height: '10px' }}
                nodeType="vrrp"
                nodeId={id}
                nodeSelected={selected}
                selectedHandleId={selectedHandleId}
                setSelectedHandleId={setSelectedHandleId}
                handleId={HANDLES_POOL[1]}
                position={mapHandleIdToUseDynamicHandlePosition[HANDLES_POOL[1]][0]}
                setInitialHandlePosition={mapHandleIdToUseDynamicHandlePosition[HANDLES_POOL[1]][1]}
                isConnectable={isConnectable}
                data={data}
                movable={isNodeDraggable}
            />
            {selected && (
                <NodeToolbar
                    HANDLES_POOL={HANDLES_POOL}
                    hidden={!selected}
                    nodeId={id}
                    NodeConfigMenuProps={{
                        internalHandlesPool: ['port0'],
                        withStaticPorts: true,
                        configureOnly: !isNodeDraggable,
                    }}
                />
            )}
        </Box>
    );
}
